import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  create(data) {
    // If files are present, send as multipart form-data
    if (data.files && data.files.length > 0) {
      const formData = new FormData();

      // Append campaign attributes as nested keys: campaign[title], etc.
      Object.keys(data).forEach(key => {
        if (key === 'files') {
          data.files.forEach(file => formData.append('files[]', file));
        } else if (key === 'audience' || key === 'trigger_rules' || key === 'template_params') {
          formData.append(`campaign[${key}]`, JSON.stringify(data[key]));
        } else {
          formData.append(`campaign[${key}]`, data[key] ?? '');
        }
      });

      return axios.post(this.url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }

    return axios.post(this.url, data);
  }
}

export default new CampaignsAPI();
